import { GridLegacy as Grid } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import { benefitsData } from './Benefits.data';
import {
  StyledFirstTitle,
  StyledServiceDescription,
  StyledServiceIcon,
  StyledServiceIconBackground,
  StyledServiceIconWrapper,
  StyledServiceItem,
  StyledServiceTitle,
  StyledStack,
  StyledTwoTitles,
} from './styles';

export const Benefits = () => {
  return (
    <Section width="small">
      <StyledStack>
        <StyledTwoTitles>
          <StyledFirstTitle variant="display_sm">
            {benefitsData.title}
          </StyledFirstTitle>
        </StyledTwoTitles>

        <Grid container columnSpacing={{ sm: 8 }} rowSpacing={{ xs: 6, sm: 8 }}>
          {benefitsData.items.map((data, index) => (
            <StyledServiceItem key={index} item xs={12} md={6}>
              <div>
                <StyledServiceIconWrapper>
                  <StyledServiceIconBackground>
                    <StyledServiceIcon src={data.icon} alt={data.title} />
                  </StyledServiceIconBackground>
                </StyledServiceIconWrapper>
              </div>
              <div>
                <StyledServiceTitle variant="strong_400">
                  {data.title}
                </StyledServiceTitle>
                <br />
                <StyledServiceDescription variant="regular_300">
                  {data.description}
                </StyledServiceDescription>
              </div>
            </StyledServiceItem>
          ))}
        </Grid>
      </StyledStack>
    </Section>
  );
};
